const dataProviderSettings = [
  {
    id: 'bluebike-boston',
    name: 'Blue Bikes',
    table: 'trips_bluebike_boston',
    urlShort: 'bluebikes.com',
    logo: '/img/logos/Blue-Bikes-SM-logo_p_WEB_v2.svg',
    logoHeight: '26px',
    location: { lat: 42.3601, lng: -71.0589 },
    timestamps: {
      startDateField: 'starttime',
      endDateField: 'stoptime',
      startTimeField: 'starttime',
      endTimeField: 'stoptime',
      durationField: 'tripduration',
      startStationId: 'startstationid',
      endStationId: 'endstationid'
    },
    city: 'Boston',
    urlTemplate: 'https://s3.amazonaws.com/hubway-data/[YYYY][MM]-bluebikes-tripdata.zip',
    urlIndex: 'https://s3.amazonaws.com/hubway-data/index.html',
    urlStationLocations: 'https://gbfs.bluebikes.com/gbfs/en/station_information.json',
    station_locations_file: 'bluebikes_boston_stations.json'
  },
  {
    id: 'citibike-nyc',
    name: 'Citibike',
    table: 'trips_citibike_nyc',
    urlShort: 'citibikenyc.com',
    logo: '/img/logos/Citi-Bike-provided-by-Lyft-Positive-170x57px.svg',
    logoHeight: '36px',
    location: { lat: 40.7228, lng: -74.0060 },
    timestamps: {
      startDateField: 'starttime',
      endDateField: 'stoptime',
      startTimeField: 'starttime',
      endTimeField: 'stoptime',
      durationField: 'tripduration',
      startStationId: 'startstationid',
      endStationId: 'endstationid'
    },
    city: 'NYC',
    urlTemplate: 'https://s3.amazonaws.com/tripdata/[YYYY][MM]-citibike-tripdata.csv.zip',
    urlIndex: 'https://s3.amazonaws.com/tripdata/index.html',
    urlStationLocations: 'https://gbfs.citibikenyc.com/gbfs/en/station_information.json',
    station_locations_file: 'citibike_nyc_station_information.json'
  },
  {
    id: 'capitalbikeshare-dc',
    name: 'Capital Bikeshare',
    table: 'trips_capitalbikeshare_dc_old',
    urlShort: 'capitalbikeshare.com',
    logo: '/img/logos/CaBi-logo_red.svg',
    logoHeight: '32px',
    location: { lat: 38.9072, lng: -77.0369 },
    timestamps: {
      startDateField: 'startdate',
      endDateField: 'enddate',
      startTimeField: 'startdate',
      endTimeField: 'enddate',
      durationField: 'duration',
      startStationId: 'startstationnumber',
      endStationId: 'endstationnumber'
    },
    city: 'DC',
    urlTemplate: 'https://s3.amazonaws.com/capitalbikeshare-data/[YYYY][MM]-capitalbikeshare-tripdata.zip',
    urlIndex: 'https://s3.amazonaws.com/capitalbikeshare-data/index.html',
    urlStationLocations: 'https://gbfs.capitalbikeshare.com/gbfs/en/station_information.json',
    station_locations_file: 'capitalbikeshare_dc_station_information.json'
  },
  {
    id: 'capitalbikeshare-dc',
    name: 'Capital Bikeshare',
    table: 'trips_capitalbikeshare_dc',
    urlShort: 'capitalbikeshare.com',
    logo: '/img/logos/CaBi-logo_red.svg',
    logoHeight: '32px',
    location: { lat: 38.9072, lng: -77.0369 },
    timestamps: {
      startDateField: 'started_at',
      endDateField: 'ended_at',
      startTimeField: 'started_at',
      endTimeField: 'ended_at',
      durationField: 'duration',
      startStationId: 'start_station_id',
      endStationId: 'end_station_id'
    },
    city: 'DC',
    urlTemplate: 'https://s3.amazonaws.com/capitalbikeshare-data/[YYYY][MM]-capitalbikeshare-tripdata.zip',
    urlIndex: 'https://s3.amazonaws.com/capitalbikeshare-data/index.html',
  },
  {
    id: 'divvy-chicago',
    name: 'Divvy Bikes',
    table: 'trips_divvy_chicago_old',
    urlShort: 'divvybikes.com',
    logo: '/img/logos/Divvy-Header-Logo.svg',
    logoHeight: '26px',
    location: { lat: 41.8781, lng: -87.6298 },
    timestamps: {
      startDateField: 'start_time',
      endDateField: 'end_time',
      startTimeField: 'start_time',
      endTimeField: 'end_time',
      durationField: 'tripduration',
      startStationId: 'from_station_id',
      endStationId: 'to_station_id'
    },
    city: 'Chicago',
    urlTemplate: 'https://divvy-tripdata.s3.amazonaws.com/Divvy_Trips_[YYYY]_Q[Q].zip',
    urlIndex: 'https://divvy-tripdata.s3.amazonaws.com/index.html',
    urlStationLocations: 'https://gbfs.divvybikes.com/gbfs/en/station_information.json',
    station_locations_file: 'divvy_chicago_station_information.json'
  },
  {
    id: 'divvy-chicago',
    name: 'Divvy Bikes',
    table: 'trips_divvy_chicago',
    urlShort: 'divvybikes.com',
    logo: '/img/logos/Divvy-Header-Logo.svg',
    logoHeight: '26px',
    location: { lat: 41.8781, lng: -87.6298 },
    timestamps: {
      startDateField: 'started_at',
      endDateField: 'ended_at',
      startTimeField: 'started_at',
      endTimeField: 'ended_at',
      durationField: 'duration',
      startStationId: 'start_station_id',
      endStationId: 'end_station_id'
    },
    city: 'Chicago',
    urlTemplate: 'https://divvy-tripdata.s3.amazonaws.com/[YYYY][MM]-divvy-tripdata.zip',
    urlIndex: 'https://divvy-tripdata.s3.amazonaws.com/index.html'
  },
  {
    id: 'biketown-portland',
    name: 'Biketown',
    table: 'trips_biketown_portland',
    urlShort: 'biketownpdx.com',
    logo: '/img/logos/Biketown-Logo.svg',
    logoHeight: '23px',
    location: { lat: 45.5051, lng: -122.6750 },
    timestamps: {
      startDateField: 'startdate',
      endDateField: 'enddate',
      startTimeField: 'starttime',
      endTimeField: 'endtime',
      durationField: 'tripduration',
      startStationId: 'starthub',
      endStationId: 'endhub'
    },
    city: 'Portland',
    urlTemplate: 'https://s3.amazonaws.com/biketown-tripdata-public/[YYYY]_[MM].csv',
    urlIndex: 'https://s3.amazonaws.com/biketown-tripdata-public/index.html',
    urlStationLocations: 'https://gbfs.biketownpdx.com/gbfs/en/station_information.json',
    station_locations_file: 'biketown_portland_station_information.json',
    unzipped: true
  },
  {
    id: 'bikeshare-la',
    name: 'Metro Bikeshare',
    table: 'trips_bikeshare_la',
    urlShort: 'metro.net',
    logo: '/img/logos/bikeshre-logo.png',
    logoHeight: '26px',
    location: { lat: 34.0522, lng: -118.2437 },
    timestamps: {
      startDateField: 'start_time',
      endDateField: 'end_time',
      startTimeField: 'start_time',
      endTimeField: 'end_time',
      durationField: 'duration',
      startStationId: 'start_station',
      endStationId: 'end_station'
    },
    city: 'LA',
    urls: [
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2021/01/metro-trips-2020-q4.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2020/10/metro-trips-2020-q3.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2020/07/metro-trips-2020-q2.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2020/04/metro-bike-share-trips-2020-q1.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2020/01/metro-bike-share-trips-2019-q4.csv.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2019/10/metro-bike-share-trips-2019-q3-1.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2019/08/metro-bike-share-trips-2019-q2.csv.zip',
      'https://11ka1d3b35pv1aah0c3m9ced-wpengine.netdna-ssl.com/wp-content/uploads/2019/04/metro-bike-share-trips-2019-q1.csv.zip'
    ],
    urlIndex: 'https://bikeshare.metro.net/about/data/',
    urlStationLocations: 'https://gbfs.bcycle.com/bcycle_lametro/station_information.json',
    station_locations_file: 'metro_la_station_information.json',
    manuallyUpdate: true
  },
];

const DATA_START_MONTH = 1
const DATA_END_MONTH = 12


module.exports = { dataProviderSettings, DATA_START_MONTH, DATA_END_MONTH }